import type { WMSInfo } from '@ais-ui/websockets';
import { createCollectionDomainHook } from './domainHookFactory';
import { wmsTranslator } from './translators/wms';

/**
 * Typed hook for the `wms` collection. Reads stay on the blob (`blobReadOnly`)
 * because the service list endpoint is a lossy summary and `selected[]` is a
 * Bucket A field consumed by `olserver`; writes dual-write to the service so it
 * is kept in sync for a later cutover. The engine item type is the rich blob
 * `WMSInfo` (not the backend's trimmed shape) so no fields are lost.
 */
export const useWmsServiceSettings = createCollectionDomainHook<WMSInfo>(
  'wms',
  'services',
  wmsTranslator,
  { blobReadOnly: true },
);
